import React, { useEffect } from "react";

import { useSelector } from "react-redux";
import { Breadcrumb, Col, Row } from "antd";
import { Link, NavLink } from "react-router-dom";

import { removeAccessToken } from "utils/storage";
import { LogoutOutlined } from "@ant-design/icons";

function Header({ name, subName }) {
  const user = useSelector((state) => state.app.user);

  useEffect(() => window.scrollTo(0, 0));

  return (
    <>
      <Row gutter={[24, 0]}>
        <Col span={24} md={6}>
          <Breadcrumb>
            <Breadcrumb.Item>
              <NavLink to="/">Pages</NavLink>
            </Breadcrumb.Item>
            <Breadcrumb.Item style={{ textTransform: "capitalize" }}>
              {name.replace("/", "")}
            </Breadcrumb.Item>
          </Breadcrumb>
          <div className="ant-page-header-heading">
            <span
              className="ant-page-header-heading-title"
              style={{ textTransform: "capitalize" }}
            >
              {subName.replace("/", "")}
            </span>
          </div>
        </Col>
        <Col span={24} md={18} className="header-control">
          {user && (
            <>
              <LogoutOutlined
                style={{ fontSize: "16px", marginLeft: "5px" }}
                onClick={() => {
                  removeAccessToken();
                  window.location.href = `${process.env.REACT_APP_OAUTH_DOMAIN}/exit?redirect_url=${window.location.href}`;
                }}
              />
              <Link className="btn-sign-in">
                <span>{user.fullname}</span>
              </Link>
            </>
          )}
        </Col>
      </Row>
    </>
  );
}

export default Header;
